import moment from "moment";

const isLeapYear = (year) => {
  const cond1 = year % 4 === 0; // 条件1：年份必须要能被4整除
  const cond2 = year % 100 !== 0; // 条件2：年份不能是整百数
  const cond3 = year % 400 === 0; // 条件3：年份是400的倍数
  // 当条件1和条件2同时成立时，就肯定是闰年，所以条件1和条件2之间为“与”的关系。
  // 如果条件1和条件2不能同时成立，但如果条件3能成立，则仍然是闰年。所以条件3与前2项为“或”的关系。
  // 所以得出判断闰年的表达式：
  const cond = (cond1 && cond2) || cond3;
  if (cond) {
    return true;
  } 
    return false;
  
};

const formatDate = (year, month, date) => {
  if (month === "02") {
    if (isLeapYear(year) && date > 29) {
      date = 29;
    } else if (!isLeapYear(year) && date > 28) {
      date = 28;
    }
  } else if (["04", "06", "09", "11"].indexOf(month) > -1) {
    if (date > 30) {
      date = 30;
    }
  }
  return `${year}-${month}-${date}`;
};

// 获取确定时间后的日期
export const getDate = (year, month, date, numMonth, days) => {
  let m = 0;
  let y = 0;
  if (month + numMonth > 12) {
    m = (month + numMonth) % 12;
    y = year + Math.floor((month + numMonth) / 12);
  } else {
    m = month + numMonth;
    y = year;
  }
  if (+m === 0) {
    m = "12";
  } else if (+m < 10) {
    m = `0${m}`;
  } else {
    m += "";
  }
  if (days) {
    return moment(formatDate(y, m, date), "YYYY-MM-DD")
      .add(days, "d")
      .valueOf();
  }
  return moment(formatDate(y, m, date), "YYYY-MM-DD").valueOf();
};

/**
 * @function {获取2个日期间相差的月数}
 * @param {YYYY-MM-DD} beginDate 开始日期
 * @param {YYYY-MM-DD} endDate 结束日期
 */
export const getMonthNums = (beginDate, endDate) => {
  const arrBeginDate = beginDate.split("-");
  const arrEndDate = endDate.split("-");
  const diffYear = arrEndDate[0] - arrBeginDate[0];
  const diffMonth =
    arrEndDate[1] -
    arrBeginDate[1] +
    12 * diffYear +
    (arrEndDate[2] - arrBeginDate[2] >= 0 ? 1 : 0);
  return diffMonth;
};



// WEBPACK FOOTER //
// ./src/util/formatDate.js